import React from 'react';
import LandingPage from './components/LandingPage';

function App() {
  return (
    <div className="min-h-screen">
      <LandingPage />
    </div>
  );
}

export default App;